import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from 'common/components/elements/inputs/checkbox-label';
import Input from "common/components/elements/inputs/inputs";

const DownloadOptions = ({
   inputName,
   onChange,
   maxPrice,
   onWrongPriceLength,
   priceValidation,
   setError,
   data,
   isDownloadPriceError,
   isDownloadDisabled,
   disabledDownloadTooltipText = '',
}) => {

   const downloadPrefix = `for_${ data.type }`
   let price = data[`download_price_${ downloadPrefix }`]
   let isFree = data[`download_is_free_${ downloadPrefix }`]
   let isAvailable = data[`download_available_${ downloadPrefix }`]
   return (
      <div className='mt-3 ml-9 flex flex-col'>
         <CheckBox
            label={ 'locked' === data.type ? 'Allow downloads after unlock' : 'Allow downloads' }
            name={ `download_available_${ downloadPrefix }_${ inputName }` }
            checked={ !!isAvailable }
            onChange={ (name, value) => {
               if(priceValidation(price, false, true)) {
                  setError('download', true)
                  return
               }
               onChange(`download_available_${ downloadPrefix }`, !isAvailable)
            } }
            textColor='secondary'
            disabled={ isDownloadDisabled }
            padding='0'
            className='w-full'
            margin='2'
            labelTooltipText={ isDownloadDisabled ? disabledDownloadTooltipText : null }
         />
         {
            !!isAvailable && (
               <div className='flex flex-col mt-3'>
                  <CheckBox
                     label='Set additional download price'
                     name={ `download_is_free_${ downloadPrefix }_${ inputName }` }
                     checked={ !isFree }
                     onChange={ (name, value) => {
                        if(priceValidation(price, true, true)) {
                           setError('download', true)
                        }
                        onChange(`download_is_free_${ downloadPrefix }`, !isFree)
                     } }
                     textColor='secondary'
                     disabled={ false }
                     padding='0'
                     className='w-full'
                     margin='2'
                  />
                  {
                     !isFree && (
                        <div className='w-full mt-3 cursor-auto'>
                           <Input
                              rightText='USD'
                              height='10'
                              value={ price }
                              name={ `download_price_${ downloadPrefix }_${ inputName }` }
                              onChange={ (name, value) => {
                                 let price = !value ? value : +value
                                 if(isDownloadPriceError && priceValidation(price, false, true)) {
                                    setError('download', false)
                                 }
                                 onChange(`download_price_${ downloadPrefix }`, price)
                              } }
                              autoComplete='off'
                              errorMessage={ isDownloadPriceError && priceValidation(price, false, true) ? `Price must be between 0.25 USD and ${ maxPrice } USD` : null }
                              onInputFocus={ _ => setError('download', false) }
                              isPriceInput
                              maxPrice={ maxPrice }
                              type={ 'number' }
                           />
                        </div>
                     )
                  }
               </div>
            )
         }
      </div>
   )
}

DownloadOptions.propTypes = {
   onChange: PropTypes.func,
   inputName: PropTypes.any,
   data: PropTypes.object,
   maxPrice: PropTypes.number,
   isDownloadPriceError: PropTypes.bool,
   onWrongPriceLength: PropTypes.func,
   priceValidation: PropTypes.func,
   setError: PropTypes.func,
   isDownloadDisabled: PropTypes.bool,
   disabledDownloadTooltipText: PropTypes.string,
}

export default DownloadOptions
